import type { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';

import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components/icon/icon';
import Icon from 'components/icon/icon';
import Typography from 'components/typography/typography';

interface LinkProps
  extends DetailedHTMLProps<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  variant: 'primary' | 'outlined' | 'danger';
  iconProps?: IconProps;
  labelClassName?: string;
  label?: string;
}
const Link: React.FC<LinkProps> = (props) => {
  const { className, labelClassName, iconProps, label, ...rest } = props;
  const anchorClassName = twMerge(
    'flex flex-row items-center py-2 px-4 rounded-md ',
    props.variant === 'primary' && 'bg-primary',
    props.variant === 'outlined' && 'bg-white border border-gray100',
    props.variant === 'danger' && 'bg-destructive',
    className,
  );

  const typographyClassName = twMerge(
    props.variant === 'primary' && 'text-white',
    props.variant === 'outlined' && 'text-gray500',
    props.variant === 'danger' && 'text-white',
    props.iconProps && 'pl-2',
    labelClassName,
  );

  return (
    <a className={anchorClassName} {...rest}>
      {iconProps && <Icon {...iconProps} />}
      <Typography
        variant="body-large-bold"
        as="p"
        className={typographyClassName}
      >
        {label}
      </Typography>
    </a>
  );
};

export default Link;
